import clsx from 'clsx';
import { formatMoney } from '../../utils/formatters';
import { ResponsibleCreditSummaryDto } from '../../services/api.types';
import { CircularProgress, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';

interface ResponsibleCreditsSummaryProps {
  className?: string;
  onClose?: () => void;
  creditSummary: ResponsibleCreditSummaryDto;
  isLoading?: boolean;
  onOpenPredictedReports?: () => void;
}

export const ResponsibleCreditsSummary = ({
  className,
  onClose,
  creditSummary,
  isLoading,
  onOpenPredictedReports,
}: ResponsibleCreditsSummaryProps) => {
  return (
    <div
      className={clsx(
        'w-full max-w-[350px] h-min',
        'flex flex-col bg-orange-light',
        'rounded-[45px] p-4 px-6 my-0.5',
        className
      )}
    >
      <div
        className={clsx(
          'w-full mb-3 text-center bg-white rounded-[45px]',
          'grid grid-cols-1-auto-1 items-center'
        )}
      >
        <div></div>
        <h3 className="px-0">Resumo</h3>
        <div>
          {onClose && (
            <IconButton onClick={onClose}>
              <Close />
            </IconButton>
          )}
        </div>
      </div>
      <div className="flex flex-col my-0 text-base gap-0 font-normal">
        {isLoading && (
          <div className="flex justify-center">
            <CircularProgress
              size="1.66rem"
              color="secondary"
              className="ml-2"
            />
          </div>
        )}

        <div className="flex flex-col p-0 mb-2">
          <p className="mt-2 mb-0">Saldo:</p>
          <b
            className={clsx('text-left', {
              'text-mui-error': creditSummary.balance < 0,
            })}
          >
            {formatMoney(creditSummary.balance, true)}
          </b>
        </div>
        <div className="flex flex-col p-0 mb-2">
          <p className="mt-2 mb-0">Pagamentos pendentes / atrasados:</p>
          <b className="text-left">
            {formatMoney(creditSummary.pendingPaymentsTotalValue)}
          </b>
        </div>
        <div className="flex items-center">
          <div className="flex flex-col p-0 mb-2">
            <p className="mt-2 mb-0">
              Aulas dadas ainda não pagas (que serão cobradas no proximo mês):
            </p>
            <b className="text-left">
              {formatMoney(creditSummary.predictedMonthlyPaymentTotalValue)}
            </b>
          </div>

          <IconButton
            title="Ver relatórios"
            className="w-min h-min"
            color="secondary"
            onClick={onOpenPredictedReports}
          >
            <DescriptionTwoToneIcon />
          </IconButton>
        </div>
      </div>
    </div>
  );
};
